import gql from 'graphql-tag'

export const BUSINESS_ENTITY_FRAGMENT = gql`
  fragment BusinessEntityFragment on BusinessEntity {
    globalId
    entityType
    isPrimary
    label
    companyNo
    companyName
    taxNo
    data
  }
`

export const COMPLIANCE_RESULT_FRAGMENT = gql`
  fragment ComplianceResultFragment on ComplianceResult {
    name
    isApplicable
    isComplete
    data
  }
`

export const PRIMARY_BUSINESS_ENTITY_ON_ACCOUNT_FRAGMENT = gql`
  fragment PrimaryBusinessEntityOnAccount on Account {
    primaryBusinessEntity {
      ...BusinessEntityFragment
    }
  }
  ${BUSINESS_ENTITY_FRAGMENT}
`

export const ACTIVE_COMPLIANCES_ON_ACCOUNT_FRAGMENT = gql`
  fragment ActiveCompliancesOnAccount on Account {
    compliances(names: $complianceNames) {
      ...ComplianceResultFragment
    }
  }
  ${COMPLIANCE_RESULT_FRAGMENT}
`

export const ACTIVE_COMPLIANCES_ON_HIRE_FRAGMENT = gql`
  fragment ActiveCompliancesOnHire on Hire {
    globalId
    compliances(names: $complianceNames) {
      ...ComplianceResultFragment
    }
  }
  ${COMPLIANCE_RESULT_FRAGMENT}
`

export const ActiveAccountBusinessEntity = gql`
  query businessEntityQuery {
    me {
      activeAccount {
        globalId
        primaryBusinessEntity {
          ...BusinessEntityFragment
        }
      }
    }
  }
  ${BUSINESS_ENTITY_FRAGMENT}
`

export function activeAccountCompliances(extraAccountFields = '') {
  return gql`
    query accountQuery($names: [ComplianceName!]!) {
      me {
        activeAccount {
          globalId
          compliances(names: $names) {
            ...ComplianceResultFragment
          }
          ${extraAccountFields}
        }
      }
    }
    ${COMPLIANCE_RESULT_FRAGMENT}
  `
}
